"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ingredientParser = void 0;
const ingredientParser_1 = require("./src/funcs/ingredientParser");
exports.ingredientParser = ingredientParser_1.default;
// const test = async () => {
//   const ingrData = await ingredientParser(
//     '1 lb boneless skinless chicken breast',
//     'e8064d74f9804ebd82a947fb7b86189b'
//   )
//   return console.log(ingrData)
// }
// test()
__exportStar(require("./types"), exports);
